import styled from 'styled-components';

import { Box } from 'components/Box/Box';
import { PrimaryButtonRouterLink } from 'components/Button';
import { LegacyTertiaryButton } from 'components/Button/LegacyTertiaryButton';
import { closeDropdownFromElementWithin } from 'components/Dropdown/closeDropdownFromElementWithin';
import { Meter } from 'components/Meter';
import ResumeDatabaseResponseContainer from 'containers/ResumeDatabaseResponseContainer';
import { colors, fontWeights } from 'theme/theme';
import { trackClicked } from 'utils/analytics/track/trackClicked';

const StyledLinkButton = styled(LegacyTertiaryButton)`
  color: ${colors.lightContentGrey};
  font-size: inherit;
  font-weight: ${fontWeights.normal};
  text-decoration: underline;
`;

type Props = {
  hasResume: boolean;
};

export function MyAccountDropdownProfileSection({ hasResume }: Props) {
  return (
    <Box
      minWidth={200}
      px={12}
      pt={16}
      pb={24}
      textAlign="center"
      borderBottom={`1px solid ${colors.selectionGrey}`}
    >
      <Box mb="8px" color={colors.lightContentGrey}>
        {getText('Your profile is incomplete')}
      </Box>
      <Meter
        current={1}
        total={3}
        color="brandGreen"
        delay={0}
        duration={0.5}
      />
      <Box mt={20} mb="8px">
        <PrimaryButtonRouterLink
          to="/dashboard/employment-profile/get-discovered"
          size="small"
          onClick={(event) => {
            closeDropdownFromElementWithin(event.target as HTMLElement);
            trackClicked('Add Resume', {
              context: 'Header User Dropdown',
            });
          }}
        >
          {hasResume ? getText('Share Resume') : getText('Add Resume')}
        </PrimaryButtonRouterLink>
      </Box>
      <Box width={1} display="flex" flexDirection="column" alignItems="center">
        <ResumeDatabaseResponseContainer>
          {({ dismiss }) => (
            <StyledLinkButton
              onClick={(e) => {
                e.preventDefault();
                dismiss();
                trackClicked('Dismiss Resume Database CTA', {
                  context: 'Header User Dropdown',
                });
              }}
            >
              {getText('No, thanks')}
            </StyledLinkButton>
          )}
        </ResumeDatabaseResponseContainer>
      </Box>
    </Box>
  );
}
